import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import i18next from 'i18next';
import 'dayjs/locale/en';
import 'dayjs/locale/de';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/es';

dayjs.extend(customParseFormat);

export namespace DateUtil {
  /** Canonical UI date formats (DE / DIN 5008). */
  export const Format = {
    date: 'DD.MM.YYYY',
    datetime: 'DD.MM.YYYY, HH:mm',
    time: 'HH:mm',
    monthYear: 'MMM YYYY',
    month: 'MMMM',
    year: 'YYYY',
  } as const;

  export function formatDate(date: any, format: string = Format.date) {
    if (!date) {
      return ' ';
    }
    const locale = i18next.language || 'en';
    return dayjs(date).locale(locale).format(format);
  }

  /** Strictly parses a UI-formatted date string (default `DD.MM.YYYY`) back into a dayjs object. */
  export function parseDate(date: string, format: string = Format.date) {
    return dayjs(date, format, true);
  }

  /** Converts a UI-formatted date string (default `DD.MM.YYYY`) into an ISO `YYYY-MM-DD` string for the API. */
  export function toISODate(date: string, format: string = Format.date) {
    return parseDate(date, format).format('YYYY-MM-DD');
  }

  /** Same-day → time; older → date. */
  export function formatTimeOrDate(date: Date | string) {
    const given = dayjs(date);
    if (!given.isValid()) {
      return ' ';
    }
    if (dayjs().diff(given, 'day') >= 1) {
      return formatDate(given, Format.date);
    }
    return formatDate(given, Format.time);
  }
}
